<template>
  <div class="yoyAnalysis mainPageBg">
    <div class="leftMenuBox">
      <TreeMenu
        @getTreeActive="getTreeActive"
        :timeList="[
          { label: '月', value: 'MONTH' },
          { label: '年', value: 'YEAR' },
        ]"
      />
    </div>
    <div class="rightBox">
      <div class="chartsBox">
        <div class="leftChart">
          <PublicEcharts
            id="'id1'"
            :chartsData="chartsData"
            :type="'lightSwitchable'"
          />
        </div>
        <div class="rightList">
          <ul>
            <li v-for="(v, i) in listData" :key="i">
              <h5 :style="{ color: colorList[i] }">
                {{ v.value | handleNumPublicFun }}
              </h5>
              <p>{{ v.name }} {{ v.unit ? v.unit : "" }}</p>
            </li>
          </ul>
        </div>
      </div>
      <div class="tableBox">
        <div class="comTitle">
          <span></span>
          <el-button
            type="primary"
            size="mini"
            style="margin-right: 20px"
            @click="exportExcel"
            v-if="authority"
            plain
            ><i class="el-icon-download el-icon--left"></i>EXCEL</el-button
          >
        </div>
        <el-table
          :data="tableData"
          id="exportTab"
          border
          stripe
          height="90%"
          style="width: 98%; margin: 0 auto"
          :header-cell-style="{
            'font-weight': 'bold',
            color: '#333',
            'background-color': '#F7F7F7',
          }"
          size="small"
        >
          <el-table-column
            v-for="(v, i) in tabHead"
            :key="i"
            :prop="v.prop"
            :label="v.label"
            align="center"
            :formatter="$setTabNumber"
          ></el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
import TreeMenu from "@/components/nengyuanguanli/EquipmentConsume/TreeMenu";
import PublicEcharts from "@/components/PublicEcharts.vue";
import api from "@/api";
import {
  dateFtt,
  judgeAuthority,
  exportExcelFun,
  matchingECNameUnit,
  handleNumDecimal,
} from "@/assets/js/utils";
import { handleExportAuthority } from "@/assets/utils/handleData.js";
import exportFile from "@/assets/js/xlsxFile";
import XLSX from "xlsx";
export default {
  components: {
    TreeMenu,
    PublicEcharts,
  },
  data() {
    return {
      authority: false,
      tableData: [],
      tabHead: [],
      colorList: ["#28CCCB", "#1890FF", "#9D87E7"],
      listData: [],
      chartsData: {
        type: "bar",
        unit: "",
        showChange: true,
        xData: [],
        dataArr: [],
      },
      activeName: "",
    };
  },
  methods: {
    getTreeActive(data) {
      this.activeName = `${data.name.name}-同比${matchingECNameUnit(
        data.activeType,
        "title"
      )}分析${data.date}`;
      this.getYoyChart(data);
      this.getRoyAnalysis(data);
      this.getRoyTable(data);
      this.$store.commit("SET_LOADING", true);
    },
    async getYoyChart(data) {
      this.chartsData.xData = [];
      this.chartsData.dataArr = [];
      this.chartsData.unit = matchingECNameUnit(data.activeType, "unit");
      let arr = [];
      let res = await api.energyRoyChart({
        assetId: data.assetId,
        data: data.date,
        type: data.type,
        energyType: data.activeType,
      });
      if (res && res.data.code == 200) {
        this.$store.commit("SET_LOADING", false);
        res.data.data.map((v) => {
          this.chartsData.xData.push(
            data.type == "MONTH"
              ? dateFtt("dd日", new Date(v.time))
              : dateFtt("MM月", new Date(v.time))
          );
          arr.push(v.value);
        });
        for (let i = 0; i < arr[0].length; i++) {
          this.chartsData.dataArr.push({ name: "", data: [] });
          arr.forEach((item) => {
            this.chartsData.dataArr[i].name = item[i].name;
            this.chartsData.dataArr[i].data.push(
              handleNumDecimal(item[i].data)
            );
          });
        }
      }
    },
    async getRoyAnalysis(data) {
      this.listData = [];
      let res = await api.energyRoyAnalysis({
        assetId: data.assetId,
        data: data.date,
        type: data.type,
        energyType: data.activeType,
      });
      if (res && res.data.code == 200) {
        this.listData = res.data.data;
      }
    },
    async getRoyTable(data) {
      this.tabHead = [
        { label: "日期", prop: "time" },
        {
          label: "本期" + matchingECNameUnit(data.activeType, "unit"),
          prop: "nowValue",
        },
        {
          label: "同期" + matchingECNameUnit(data.activeType, "unit"),
          prop: "beforeValue",
        },
        { label: "同比值%", prop: "yearOnYear" },
        { label: "累计同比%", prop: "cumulativeYearOnYear" },
      ];
      this.tableData = [];
      let res = await api.energyRoyTable({
        assetId: data.assetId,
        data: data.date,
        type: data.type,
        energyType: data.activeType,
      });
      if (res && res.data.code == 200) {
        this.tableData = res.data.data;
        this.tableData.map((v) => {
          v.time =
            data.type == "MONTH"
              ? dateFtt("dd日", new Date(v.ts))
              : dateFtt("MM月", new Date(v.ts));
        });
      }
    },
    exportExcel() {
      exportFile.xlsxFile(XLSX, this.activeName, {
        excel: exportExcelFun(this.tabHead, this.tableData),
      });
    },
  },
  created() {
    this.authority = judgeAuthority(handleExportAuthority(this.$route.path));
  },
};
</script>

<style lang="scss" scoped>
.yoyAnalysis {
  @include setFlexBetween;
  .leftMenuBox {
    @include setMenuWH;
  }
  .rightBox {
    // @include setCenterWH;
    width: calc(79% - 12px);
    height: 100%;
    .chartsBox {
      width: 100%;
      margin: 0 0 12px 0;
      height: 400px;
      background: #fff;
      border-radius: 12px;
      @include setFlexBetween;
      .leftChart {
        width: 74%;
        height: 95%;
      }
      .rightList {
        width: 25%;
        height: 95%;
        ul {
          width: 90%;
          height: 100%;
          margin: 0 auto;
          li {
            height: 33%;
            width: 100%;
            border-bottom: 1px solid #dddddd;
            @include setFlexColumn;
            justify-content: center;
            align-items: center;
            h5 {
              font-size: 28px;
            }
            p {
              color: #666;
            }
          }
          li:last-child {
            border: none;
          }
        }
      }
    }
    .tableBox {
      width: 100%;
      height: calc(100% - 435px);
      border-radius: 12px;
      background: #fff;
      padding-bottom: 20px;
      .comTitle {
        @include setFlexBetween;
        height: 42px;
        background-color: #fff;
      }
    }
  }
}
</style>
